import { render, staticRenderFns } from "./MultiPolTypeByAppIdHelpList.vue?vue&type=template&id=e97a53f6&"
import script from "./MultiPolTypeByAppIdHelpList.vue?vue&type=script&lang=js&"
export * from "./MultiPolTypeByAppIdHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports